// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles_badge__M32rW","container":"styles_container__IjvuC","close":"styles_close__0dFX0","confirm":"styles_confirm__2TZmM","dropdown":"styles_dropdown__ybyOz"};